import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  agreements: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  agreements: state => state.agreements,

  getById: (state) => (id) => {
    return state.agreements.find(agreement => agreement.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of projects.
   */
  getList ({ commit }, id, payload) {
    return http.get(`/project-agreements/list`).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the projects state.
  */
  [SET_LIST] (state, agreements) {
    state.agreements = agreements
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
